import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { beautifulAddressEnabled } from 'reactApp/appHelpers/featuresHelpers/features/beautifulAddress';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { SUMMER_PROMO_2026_MODAL_QUERY_PARAM } from 'reactApp/modules/promoNew/items/summerCampaign2026ModalCreator';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { BEAUTIFULL_ADDRESS_MODAL_ID, openBeautifulAddressDialog } from 'reactApp/sections/QuotaLanding/BeautifulAddress/BeautifulAddress';
import { store } from 'reactApp/store';
import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

export function* initBeautifulAddressPromo() {
    const storage = yield* select(getCurrentStorage);
    const { isQuotaCleaner } = getStorage(storage);
    const searchParams = new URLSearchParams(window.location.search);

    if (
        !beautifulAddressEnabled ||
        IS_AUTO_TEST_HIDE ||
        storeHelper.getValue(BEAUTIFULL_ADDRESS_MODAL_ID) ||
        !isQuotaCleaner ||
        // Не показываем поверх акционной модалки летней акции, открытой по прямой ссылке
        searchParams.get(SUMMER_PROMO_2026_MODAL_QUERY_PARAM)
    ) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.beautifulAddressModal,
            promoId: BEAUTIFULL_ADDRESS_MODAL_ID,
            onShow: () => {
                store.dispatch(promoShown(EPromoType.beautifulAddressModal));
                storeHelper.markAsShown(BEAUTIFULL_ADDRESS_MODAL_ID);
            },
            onClose: () => {
                store.dispatch(removePromo(EPromoType.beautifulAddressModal));
                storeHelper.markAsShown(BEAUTIFULL_ADDRESS_MODAL_ID);
            },
        })
    );
}

export function* showBeautifulAddressPromo() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.beautifulAddressModal));

    if (promo) {
        const { onShow, onClose } = promo;

        yield openBeautifulAddressDialog({
            onClose,
            onShow,
        });
    }
}
